module.exports = "<p>The artist on<br><em>Meditation for Suburbbrain</em> 2011</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room1/audio1/small_suburb_brain_description.md
// module id = 828
// module chunks = 0